import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterSegments } from 'src/app/models/router-segments';
import { Permission } from '../../models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {TenantList} from 'src/app/models/tenant/tenant';
import { TenantOnboardingDetailsComponent } from '../tenant-onboarding/tenant-onboarding-details/tenant-onboarding-details.component';
import { combineLatest, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { CreateTenantComponent } from '../tenants-mgmt/create-tenant/create-tenant.component';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import {Constants} from 'src/app/models/constants';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { ManagementTypes } from 'src/app/models/management-type';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { WorkflowDiagramComponent } from 'src/app/components/workflow-diagram/workflow-diagram.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { TenantStatus } from 'src/app/models/tenant/tenant-status';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from '../../models/principal/permission';

const REQUIRED_PERMISSIONS = [
   Permission.ADD_TENANT,
  {
      key: PermissionKeys.TENANT_READ,
      action: Permissions.TENANT_READ,
  },
];

@Component({
    selector: 'app-tenant-mgmt-list',
    templateUrl: './tenant-mgmt-list.component.html',
    styleUrls: ['./tenant-mgmt-list.component.scss'],
    standalone: false
})
export class TenantMgmtListComponent   implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() selectedItem: any;
  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  Constants = Constants;
  tenant: string;
  enterpriseClient: boolean;
  breadcrumbItems: BreadcrumbItem[];
  ManagementTypes = ManagementTypes;
  SubscriptionTypes = SubscriptionTypes;
  RouterSegments = RouterSegments;
  data: any;
  tenantData: any;
  managementType: any;

  displayedColumns: string[] = ['tenantId', 'region', 'target', 'status'];
  dataSource: any;
  selectedMenuItem: any;
  dashboard: any;
  showSpinner: any;
  dropdownsList: any = [];
  dashboardLink: any;
  tenantLink: any;
  instancesCount = 0;
  region: any;
  status: any;
  cloud: any;
  filteredColumns: any;
  clearData: boolean;
  subscription: Subscription;
  isReader: boolean;
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  isFailed = false;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  dataWorkflow: any;
  regionList: any;
  statusList: any;

  workflowDetails = {
    azure: { pii: false, nonPii: false },
    aws: {}
  };

  TenantStatus = TenantStatus;
  onboardedTenant = 0;
  environments = 0;
  azureCount = 0;
  awsCount = 0;
  foundationCount = 0;
  nonFoundationCount = 0;
  dataZoneCount: any;
  lastThreeMonthsCount = 0;
  envDataLoaded = false;
  initialData: any;
  filters = {
    managementType: '',
    status: '',
    targetCloud: '',
    regionPair: ''
  };

  filteredData: any[] = [];

  readonly statusInfo: { [key: string]: any } = {
      [TenantStatus.IMPLEMENTATION]: {icon: 'loader', colorClass: 'accent-1-bg'},
      [TenantStatus.LIVE]: {icon: 'check', colorClass: 'green-1-bg'},
      [TenantStatus.OBSOLETE]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
  };
  
  constructor(private route: ActivatedRoute, private authService: AuthService, private tenantService: TenantService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, public dateTimeFormatService: DateTimeFormatService,
    private instanceService: InstancesService, private permissionsService: PermissionsService,
    private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private router: Router) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], { skipLocationChange: true });
    }
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.TENANT';
    const regionData = localStorage.getItem('filteredRegion');
    const typeData = localStorage.getItem('filteredTenantType');
    if(typeData !== undefined){
      this.managementType = typeData;
    }
    if(regionData !== undefined){
      this.region = regionData;
    }
    const cloudData = localStorage.getItem('filteredCloud');
    if(cloudData !== undefined){
      this.cloud = cloudData;
    }
    const statusData = localStorage.getItem('filteredStatusTenant');
    if(statusData !== undefined){
      this.status = statusData;
    }
    this.dashboardLink = ({label: translate('LEFT_SIDE_NAV.DASHBOARDS')});
    this.tenantLink = ({label: translate('LEFT_SIDE_NAV.TENANT'), url: ['tenants']});

    const regionOptions = [
      {value: 'APAC' , selected: false},
      {value: 'APAC_2' , selected: false},
      {value: 'AUSTRALIA' , selected: false},
      {value: 'AUSTRALIA_2' , selected: false},
      {value: 'BRAZIL' , selected: false},
      {value: 'BRAZIL_2' , selected: false},
      {value: 'CANADA' , selected: false},
      {value: 'EUROPE' , selected: false},
      {value: 'FRANCE' , selected: false},
      {value: 'GERMANY' , selected: false},
      {value: 'INDIA' , selected: false},
      {value: 'JAPAN' , selected: false},
      {value: 'KOREA' , selected: false},
      {value: 'NORWAY' , selected: false},
      {value: 'SOUTH_AFRICA' , selected: false},
      {value: 'SWEDEN' , selected: false},
      {value: 'SWITZERLAND' , selected: false},
      {value: 'UK' , selected: false},
      {value: 'NORTH_AMERICA' , selected: false},
      {value: 'NORTH_AMERICA_2' , selected: false},
      {value: 'NORTH_AMERICA_3' , selected: false},
      {value: 'NORTH_AMERICA_4' , selected: false},
      {value: 'UAE' , selected: false}
    ];
    const cloudOptions = [ {value: 'AWS' , selected: false},
    {value: 'Azure' , selected: false}
   ];
    const statusOptions = [
      {value: TenantStatus.IMPLEMENTATION , selected: false},
      {value: TenantStatus.LIVE , selected: false},
      {value: TenantStatus.OBSOLETE , selected: false}
    ];
    const typeOptions = [
      {value: ManagementTypes.EXTERNAL, label: translate('TENANT_FORM.2.0_COUNT'), selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Type',
        placeholder: 'Select Type',
        options: typeOptions
      },
      {
        title: 'Region',
        placeholder: 'Select Region',
        options: []
      },
      {
        title: 'Cloud',
        placeholder: 'Select Cloud',
        options: cloudOptions
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: []
      }
    ];
    this.clearData = true;
    this.showSpinner = true;
    this.tenant = this.authService.principal.provider;
    this.breadcrumbs();
    this.regionList = [...new Set(regionOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.regionList.forEach((value) => {
      this.dropdownsList[1].options.push({value, selected: false});
    });
    this.statusList = [...new Set(statusOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.statusList.forEach((value) => {
      this.dropdownsList[3].options.push({value, selected: false});
    });
    this.tenantService.getTenants(undefined, this.managementType, this.region ? this.region : undefined, undefined, undefined,
    this.cloud ? this.cloud : undefined,
              this.status ? this.status : undefined)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.initialData = data;
          this.applyFilters();          
          this.showSpinner = false;
          this.orderByStatus();
          const activeData = this.data?.filter(tenant => tenant.status !== TenantStatus.OBSOLETE);
          this.onboardedTenant = activeData?.length;
          this.azureCount = activeData?.filter(result => (result.targetCloud || result.cloudProvider) === 'Azure')?.length;
          this.awsCount = activeData?.filter(result => (result.targetCloud || result.cloudProvider) === 'AWS')?.length;
          this.nonFoundationCount = activeData?.filter(result => result?.origin === 'external')?.length;
          this.foundationCount = activeData?.filter(result => result?.origin !== 'external')?.length;          
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        this.showSpinner = false;
        this.isFailed = true;
      });

    this.instanceService.getInstances()
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          const instanceObj = {
            size: data.total,
          };
          this.instanceService.getInstances(instanceObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instances => {
              const excluded = [DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED, DeployStatus.TERMINATING];
              const filtered = instances?.data?.filter(item => !excluded.includes(item.status?.toLowerCase()));
              this.dataZoneCount = filtered.reduce(
              (acc, item) => {
                const zone = item.dataZone?.toLowerCase();

                if (zone === 'pii') acc.pii++;
                if (zone === 'nonpii') acc.nonpii++;
                if (zone === 'prod') acc.prod++;

                return acc;
              },
              { pii: 0, nonpii: 0, prod: 0 }
            );
            this.instancesCount = this.dataZoneCount?.pii + this.dataZoneCount?.nonpii + this.dataZoneCount?.prod;
            this.envDataLoaded = true;
            const today = new Date();
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(today.getMonth() - 3);
            this.lastThreeMonthsCount = filtered.filter(item => {
              if (!item.dateCreated) return false;
              const createdDate = new Date(item.dateCreated);
              return createdDate >= threeMonthsAgo && createdDate <= today;
            }).length;
          });
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  orderByStatus() {
    const statusOrder: Record<string, number> = {
      [TenantStatus.IMPLEMENTATION]: 1,
      [TenantStatus.LIVE]: 2,
      [TenantStatus.OBSOLETE]: 3
    };

    this.data = this.filteredData.sort((a, b) => {
      const aRank = statusOrder[a.status] ?? 4;
      const bRank = statusOrder[b.status] ?? 4;
      return aRank - bRank;
    });
    this.loadData(this.data);
  }

  applyFilters() {
    this.filters.managementType = this.managementType;
    this.filters.regionPair = this.region;
    this.filters.targetCloud = this.cloud;
    this.filters.status = this.status;
    this.filteredData = this.initialData.filter(item =>
      (!this.filters.managementType || this.match(item.origin, this.filters.managementType)) &&
      (!this.filters.status || this.match(item.status, this.filters.status)) &&
      (!this.filters.targetCloud || this.match(item.targetCloud || item?.cloudProvider || '', this.filters.targetCloud)) &&
      (!this.filters.regionPair || this.match(item.regionPair, this.filters.regionPair))
    );
  }

  match(val: string, filter: string) {
    return val?.toLowerCase() === filter.toLowerCase();
  }

  loadData(data?): void {
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(event): void {
    this.sort = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.data = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.data?.slice(this.pageIndex, this.paginationSize));
  }

  sortInstanceData(event): any {
    return this.data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'tenantId':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'region':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'target':
          comparatorResult = a?.tenantId && b?.tenantId ? a?.tenantId?.localeCompare(b?.tenantId) : !a?.tenantId ? -1 : 1;
          break;
        case 'status':
            comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status) : !a?.status ? -1 : 1;
          break;
        case 'dateCreated':
          comparatorResult = a?.dateCreated && b?.dateCreated ? new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime()
            : !a?.dateCreated ? -1 : 1;
          break;
        default:
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  gotoSection(menuItem: any): void {
    this.selectedMenuItem = menuItem;
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
      this.breadcrumbItems.push({icon: 'home'}, {label: this.dashboardLink.label, url:[]}, {label: this.tenantLink.label,
        url: this.tenantLink.url});
  }

  openTenanteDetails(tenant): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT_DETAILS, tenant]);
  }

  tenantDetails(tenant): any {
    const instanceObj = {
      tenantId: tenant.tenantId,
      pageSize: this.instancesCount
    };
    this.tenantService.getTenantAccountDetails(tenant.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.tenantData = data;
          this.getInstancesForPopup(instanceObj, tenant);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        this.getInstancesForPopup(instanceObj, tenant);
      });
  }

  getInstancesForPopup(instanceObj, tenant): void {
    this.instanceService.getInstances(instanceObj)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((instances) => {
      if (instances) {
        return this.sidenavService.openInRightSidenav(TenantOnboardingDetailsComponent,
          {accountData: this.tenantData, tenantData: tenant, instancesData: instances.data});
      }
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.sidenavService.openInRightSidenav(TenantOnboardingDetailsComponent, {accountData: this.tenantData, tenantData: tenant});
    });
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event?.pageIndex;
      this.paginationSize = event?.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.data.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  selectionChanged(): void {
    this.showSpinner = true;
    this.applyFilters();
    this.orderByStatus();
    this.loadData(this.data);
    this.showSpinner = false;
  }

  closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  filterColumns(): void {
    if(this.managementType) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.managementType) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.region) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.region) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.cloud) {
      this.dropdownsList[2].options.filter((item) => {
        if (item.value === this.cloud) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.status) {
      this.dropdownsList[3].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[3].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.TENANT'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      type: this.dropdownsList[0].options,
      region: this.dropdownsList[1].options,
      cloud: this.dropdownsList[2].options,
      status: this.dropdownsList[3].options,
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(filteredColumns => {
          if (!filteredColumns || !Array.isArray(filteredColumns)) {
            return;
          }
          this.clearData = true;
          this.tenant = undefined;

          this.managementType = filteredColumns?.[0] || undefined;
          this.region = filteredColumns?.[1] || undefined;
          this.cloud = filteredColumns?.[2] || undefined;
          this.status = filteredColumns?.[3] || undefined;

          this.getTenantsData();
        });
  }

  filteredColumnsFunction(data): void {
    if(this.managementType === data) {
      this.managementType = undefined;
      this.resetValue(this.dropdownsList[0]);
    }else if(this.region === data) {
      this.region = undefined;
      this.resetValue(this.dropdownsList[1]);
    }else if(this.cloud === data) {
      this.cloud = undefined;
      this.resetValue(this.dropdownsList[2]);
    } else if(this.status === data) {
      this.status = undefined;
      this.resetValue(this.dropdownsList[3]);
    }
    this.getTenantsData();
  }

  getTenantsData(): void {
    this.showSpinner = true;
    this.isFailed = false;
    if(this.managementType) {
      localStorage.setItem('filteredTenantType', this.managementType);
    } else {
      localStorage.removeItem('filteredTenantType');
    }
    if(this.region) {
      localStorage.setItem('filteredRegion', this.region);
      } else {
        localStorage.removeItem('filteredRegion');
      }
      if(this.cloud) {
        localStorage.setItem('filteredCloud', this.cloud);
        } else {
          localStorage.removeItem('filteredCloud');
        }
        if(this.status) {
          localStorage.setItem('filteredStatusTenant', this.status);
          } else {
            localStorage.removeItem('filteredStatusTenant');
          }

    this.applyFilters();
    this.orderByStatus();
    this.loadData(this.data);
    this.showSpinner = false;
  }

  openWorkflowDiagram(data): void {
    combineLatest([this.tenantService.getTenantAccountDetails(data.tenantId), this.tenantService.getTenantDetails(data.tenantId)])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(([workflow, tenantDetails])=> {
      this.dataWorkflow = workflow;
      this.dataWorkflow.forEach(element => {
        if(element.azureDetails?.subscriptionId && element.dataZone === SubscriptionTypes.PII) {
          this.workflowDetails.azure.pii = true;
        }
        if(element.azureDetails?.subscriptionId && element.dataZone === SubscriptionTypes.TEST) {
          this.workflowDetails.azure.nonPii = true;
        }
      });

      this.dialog.open(WorkflowDiagramComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '1100px',
        autoFocus: false,
        data: {
          workflowDetails: this.workflowDetails,
          tenant: data.tenantId,
          tenantDetails
        }
      });

    });
  }

  resetFilter(): void {
    this.managementType = undefined;
    this.region = undefined;
    this.cloud = undefined;
    this.status = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.getTenantsData();
  }

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  resetAllValues(): void {
     this.dropdownsList.forEach(element => {
      element?.options?.forEach(item => {
        item.selected = false;
      });
    });
  }

}
